import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { ComponentCommonFaqComponent } from '@/graphql/generated/graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateFaq({
  component,
  text = 'FAQ',
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonFaqComponent;
  text?: string;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <div
      className={classNames(className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      <h1 className="mb-2 text-sh-md font-bold">{text}</h1>
      <Accordion type="multiple">
        {component?.faq?.map((faq, index) => {
          return (
            <AccordionItem key={`faq-${index}`} value={faq?.title || ''}>
              <AccordionTrigger>{faq?.title}</AccordionTrigger>
              <AccordionContent className="pl-6">{faq?.description}</AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}
